import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PositionBadge from "../../components/PositionBadge";
import ScheduleBadge from "../../components/ScheduleBadge";
import {
  Container,
  BadgeList,
  Footer,
  FooterText,
  BoldText,
  ScheduleText,
  ScheduledWrapper,
} from "./DashboardStyles";
import { getQueue } from "../../services/stationsService";
import { AppError } from "../../services/classes";
import { getNextSchedule } from "../../services/schedulingService";
import { setLoading } from "../../stores/MainStore/MainStore";
import { ScheduledVehicle } from "../../types/scheduling.types";

interface VehicleData {
  id: number;
  position: number;
  plate: string;
}

const Dashboard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const station = searchParams.get("station") ?? "";
  const token = searchParams.get("token") ?? "";

  const [vehicleData, setVehicleData] = useState<VehicleData[]>([]);
  const [scheduled, setScheduled] = useState<ScheduledVehicle>(
    {} as ScheduledVehicle
  );
  const [estimatedTime, setEstimatedTime] = useState(0);

  useEffect(() => {
    const fetchQueue = () => {
      if (station !== "" && token !== "") {
        getQueue(station, token)
          .then((data) => {
            const plates: VehicleData[] = [];
            data.queue.forEach((item: any, index: any) => {
              plates.push({
                id: index,
                position: index + 1,
                plate: item.plate,
              });
            });
            setVehicleData(plates);
            setEstimatedTime(data.waitTime);
          })
          .catch((error) => {
            console.error("Erro ao buscar fila: ", error);
          });
      }
    };

    fetchQueue();

    const intervalId = setInterval(fetchQueue, 30000);

    return () => clearInterval(intervalId);
  }, [station, token]);

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | undefined = undefined;

    if (station !== "") {
      getNextScheduleRequest();

      intervalId = setInterval(getNextScheduleRequest, 30000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNextScheduleRequest = () => {
    setLoading(true);
    getNextSchedule(station)
      .then((scheduledVehicle) => {
        setScheduled(scheduledVehicle);
      })
      .catch((err: AppError) => {
        console.log(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderScheduled = () => {
    if (!scheduled.licencePlate) {
      return <ScheduleText>Agendamento em breve</ScheduleText>;
    }

    return (
      <>
        <ScheduleText>Próximo agendamento</ScheduleText>
        <ScheduledWrapper>
          <ScheduleBadge
            key={scheduled.licencePlate}
            time={scheduled.scheduledTime}
            plate={scheduled.licencePlate}
          />
        </ScheduledWrapper>
      </>
    );
  };

  return (
    <Container>
      {renderScheduled()}
      <BadgeList>
        {vehicleData.map((vehicle) => (
          <PositionBadge
            key={vehicle.id}
            position={vehicle.position}
            plate={vehicle.plate}
          />
        ))}
      </BadgeList>
      <Footer>
        {estimatedTime > 0 ? (
          <FooterText>
            <BoldText>
              {estimatedTime} {estimatedTime > 1 ? " minutos" : "minuto"}
            </BoldText>
          </FooterText>
        ) : (
          <FooterText>Sem fila</FooterText>
        )}
      </Footer>
    </Container>
  );
};

export default Dashboard;
